import React, { useState } from 'react'
import { Box, Collapse, Grid2 } from '@mui/material'
import Select from '../../../../components/forms/Select'
import i18n from '../../../../simple-react-i18n'
import { getQualificationSelectOptions, getStatusSelectOptions } from '../../../../utils/StatusUtil'
import NumberField from '../../../../components/forms/NumberField'
import MultiContributorsAutocomplete
    from '../../../../referencial/components/contributor/components/MultiContributorsAutocomplete'
import { validationSelectFiltersType } from '../../../shapes/HydroShapes'
import PropTypes from 'prop-types'
import { shallowEqual, useSelector } from 'react-redux'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

const ValidationSeeMoreCriterias = ({
    selectFilters,
    changeSelectFilters,
    isValidateActive,
}) => {
    const [seeMoreCriterias, setSeeMoreCriterias] = useState(false)
    const {
        contributors,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
    }), shallowEqual)
    const Icon = seeMoreCriterias ? ExpandLess : ExpandMore
    return (
        <>
            <Collapse in={seeMoreCriterias}>
                <Grid2 container spacing={1}>
                    <Grid2 size={6}>
                        <Select
                            label={ i18n.status }
                            value={ selectFilters.filterStatus }
                            noSort
                            onChange={ v => changeSelectFilters({ filterStatus: v }) }
                            options={ getStatusSelectOptions() }
                            disabled={ isValidateActive }
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <Select
                            label={ i18n.qualification }
                            value={ selectFilters.filterQualification }
                            noSort
                            onChange={ v => changeSelectFilters({ filterQualification: v }) }
                            options={ getQualificationSelectOptions() }
                            disabled={ isValidateActive }
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <NumberField
                            title={i18n.valeurSup}
                            value={ selectFilters.filterSuperior }
                            noSort
                            onChange={ v => changeSelectFilters({ filterSuperior: v }) }
                            floatValue
                            disabled={ isValidateActive }
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <NumberField
                            title={i18n.valeurInf}
                            value={ selectFilters.filterInferior }
                            noSort
                            onChange={ v => changeSelectFilters({ filterInferior: v }) }
                            floatValue
                            disabled={ isValidateActive }
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        <MultiContributorsAutocomplete
                            label={i18n.producer}
                            values={ selectFilters.filterProducer }
                            onChange={ v => changeSelectFilters({ filterProducer: v }) }
                            options={ contributors }
                            disabled={ isValidateActive }
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <MultiContributorsAutocomplete
                            label={i18n.administrator}
                            onChange={ v => changeSelectFilters({ filterManager: v }) }
                            values={ selectFilters.filterManager }
                            options={ contributors }
                            disabled={ isValidateActive }
                        />
                    </Grid2>
                    <Grid2 size={6}>
                        <MultiContributorsAutocomplete
                            label={i18n.validator}
                            values={ selectFilters.filterValidator }
                            onChange={ v => changeSelectFilters({ filterValidator: v }) }
                            options={ contributors }
                            disabled={ isValidateActive }
                        />
                    </Grid2>
                </Grid2>
            </Collapse>
            <div style={{ height: 0 }}>
                <Box
                    sx={{
                        backgroundColor: '#d9dfe4',
                        border: '1px solid #000',
                        borderRadius: '20px',
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 25,
                        height: 25,
                        cursor: 'pointer',
                        position: 'relative',
                        top: -5,
                        left: -14,
                    }}
                >
                    <Icon onClick={() => setSeeMoreCriterias(prev => !prev)}/>
                </Box>
            </div>
        </>
    )
}

ValidationSeeMoreCriterias.propTypes = {
    selectFilters: validationSelectFiltersType,
    changeSelectFilters: PropTypes.func,
    isValidateActive: PropTypes.bool,
}

export default ValidationSeeMoreCriterias